import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbFileListInnerSmallBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`file-list-inner-small ${props.attributes.className ? props.attributes.className : ''} ${classes.fileListInnerSmall}`}>
        <div className="head-col">
            {blocks[0]}
        </div>
        <div className="cta-col">
            {blocks[1]}
        </div>
    </div>
};

export const CgbFileListInnerSmallBlockFragment = graphql`
  fragment CgbFileListInnerSmallBlock on WpBlock {
    ... on WpCgbFileListInnerSmallBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbFileListInnerSmallBlockPreview = `
    ... on CgbFileListInnerSmallBlock {
        name
        attributes {
            className
        }
    }
`;